/**
 * tRPC Hooks for Auth Portal
 *
 * Type-safe React hooks for auth-related API calls.
 * Note: Auth portal primarily uses Firebase Auth directly,
 * but may use tRPC for additional API calls.
 *
 * @module lib/trpc/hooks
 */

import { trpc } from './client';

// ============================================================================
// USER HOOKS (for authenticated users)
// ============================================================================

export function useCurrentUser() {
  return trpc.users.me.useQuery(undefined, {
    // Only query if user might be logged in
    retry: false,
  });
}

// ============================================================================
// BUSINESS BRANDING (PUBLIC - for white-label auth pages)
// ============================================================================

/**
 * Fetch public business branding for white-label auth pages
 * Returns business name, logo, and colors without authentication
 */
export function useBusinessBranding(businessId: string | null) {
  return trpc.businessProfile.getBrandingPublic.useQuery(
    { businessId: businessId! },
    {
      enabled: !!businessId,
      staleTime: 1000 * 60 * 5, // Cache for 5 minutes
      retry: 1,
    },
  );
}

// ============================================================================
// HEALTH CHECK
// ============================================================================

export function useHealthCheck() {
  return trpc.health.useQuery();
}
